import { render, staticRenderFns } from "./InitialDialog.vue?vue&type=template&id=447164ea&scoped=true&lang=pug&"
import script from "./InitialDialog.vue?vue&type=script&lang=js&"
export * from "./InitialDialog.vue?vue&type=script&lang=js&"
import style0 from "./InitialDialog.vue?vue&type=style&index=0&id=447164ea&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447164ea",
  null
  
)

export default component.exports